import React from "react";
import { aboutText, companyInfo } from "../data/mockData";
import { Phone, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AboutSection = ({ onBookingOpen }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <section id="about" className="py-28 bg-[#f5f5f7]">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
        >
          {/* Left: Content */}
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-sm font-medium text-[#4a7c59] tracking-widest uppercase mb-4"
            >
              Über uns
            </motion.p>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-4xl md:text-5xl font-bold text-[#1d1d1f] tracking-tight mb-8 leading-tight"
            >
              {aboutText.heading}
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-[#6e6e73] leading-relaxed mb-5 text-base"
            >
              {aboutText.paragraph1}
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="text-[#6e6e73] leading-relaxed mb-8 text-base"
            >
              {aboutText.paragraph2}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="bg-white rounded-2xl p-6 mb-8 border border-[#e5e5e5]"
            >
              <p className="text-[#1d1d1f] font-semibold text-lg mb-1">
                {aboutText.highlight}
              </p>
              <p className="text-[#6e6e73] text-sm">{aboutText.cta}</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="flex flex-wrap gap-3"
            >
              <button
                onClick={onBookingOpen}
                className="group flex items-center gap-2 bg-[#4a7c59] hover:bg-[#3d6a4a] text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105"
              >
                <Phone size={14} />
                Jetzt anrufen
              </button>
              <a
                href="#contact"
                className="group flex items-center gap-1 text-[#4a7c59] text-sm font-medium hover:underline"
              >
                Kontakt aufnehmen
                <ChevronRight
                  size={14}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </a>
            </motion.div>
          </div>

          {/* Right: Interactive Map */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/10 border border-[#e5e5e5]">
              <iframe
                src="/partnerkarte.html"
                className="w-full h-[500px] border-0"
                title="PartnerLIFT Karte"
              />
            </div>

            {/* Floating card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 shadow-xl shadow-black/5 border border-[#e5e5e5]"
            >
              <p className="text-3xl font-bold text-[#4a7c59] mb-0.5">120+</p>
              <p className="text-xs text-[#6e6e73]">Partner deutschlandweit</p>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
